<template>
  <input
    v-model="title"
    maxlength="1000"
    placeholder="Subject"
    class="border-0 bg-background font-mono font-bold ring-0 placeholder:text-muted-foreground focus:ring-0"
    @keydown="handleKeyDown"
  />
</template>

<script setup lang="ts">
const title = defineModel<string>({ required: true });

const emit = defineEmits<{
  focusEditor: [ev: KeyboardEvent];
}>();

const handleKeyDown = (ev: KeyboardEvent) => {
  const input = ev.currentTarget as HTMLInputElement;
  const key = ev.key;

  if (
    (key === "ArrowRight" &&
      input.selectionStart === input.selectionEnd &&
      input.selectionStart === title.value.length) ||
    key === "ArrowDown" ||
    key === "Enter"
  ) {
    emit("focusEditor", ev);
  }
};
</script>
